// HTTP
export const HTTP_POST = 'POST';
export const GET = 'GET';
export const HTTP_CODE_401 = 401;

export const SETTINGS_PAGE = 'settings';
export const LOGIN_ACTION = 'login';
export const LOGOUT_ACTION = 'logout';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
// Procedures
export const CHECKIN = 'lifesize.checkin';
export const FEATURE_SERVICE_ENDPOINT = 'lifesize.featureFlags.v2';

// Checkin values
export const GUEST = 'GUEST';

// Feature Flags
export const FEATURE_FLAG_ONE_TIME_MEETING = 'WEB_enableOneTimeMeetings';

// Error
export const WAMP_JWT_ERROR = 'wamp.error.jwt_error';

// Urls
export const loginAppUrl = process.env.REACT_APP_WEB_APP_URL || '';
export const logoutAppUrl = process.env.REACT_APP_LOGOUT_URL || '';
export const loginDomain = process.env.REACT_APP_LOGIN_DOMAIN || '';
export const nucleusProxy = process.env.REACT_APP_NUCLEUS_PROXY || '';
export const otherWaysToCall = process.env.REACT_APP_OTHER_WAYS_URL || '';
export const appDomain = process.env.REACT_APP_LOGIN_DOMAIN || '';
export const NO_OFFICE = process.env.REACT_APP_NO_OFFICE || false;
